module.exports = __webpack_public_path__ + "bd64812ad355123382246215ed1122de.pdf";